import { getBreakpoints } from "./media.js";
const getAlias = (base) => ({
  space: {
    ...base.spaces,
    xxxs: base.spaces[1],
    xxs: base.spaces[2],
    xxs2: base.spaces[3],
    xs: base.spaces[4],
    s: base.spaces[5],
    m: base.spaces[6],
    l: base.spaces[7],
    xl: base.spaces[8],
    xxl: base.spaces[9]
  },
  fontSizes: {
    ...base.fontSizes,
    title: {
      "500": base.fontSizes[3],
      "600": base.fontSizes[4],
      "700": base.fontSizes[5],
      "800": base.fontSizes[6],
      "900": base.fontSizes[7]
    },
    subTitle: {
      "300": base.fontSizes[1],
      "400": base.fontSizes[2]
    },
    label: {
      "200": base.fontSizes[0],
      "300": base.fontSizes[1],
      "400": base.fontSizes[2]
    },
    value: {
      "300": base.fontSizes[1],
      "400": base.fontSizes[2],
      "500": base.fontSizes[3],
      "600": base.fontSizes[4]
    },
    hyperlink: {
      "200": base.fontSizes[0],
      "300": base.fontSizes[1],
      "400": base.fontSizes[2]
    },
    microText: {
      "200": base.fontSizes[0]
    }
  },
  fontWeights: {
    ...base.fontWeights,
    thin: base.fontWeights[0],
    light: base.fontWeights[1],
    regular: base.fontWeights[3],
    semibold: base.fontWeights[5],
    bold: base.fontWeights[8]
  },
  lineHeights: {
    ...base.lineHeights,
    r: base.lineHeights[0],
    m: base.lineHeights[1],
    l: base.lineHeights[2],
    xl: base.lineHeights[3]
  },
  letterSpacings: {
    normal: base.letterSpacings[0],
    tracked: base.letterSpacings[1],
    tight: base.letterSpacings[2],
    mega: base.letterSpacings[3]
  },
  fonts: {
    ...base.fonts,
    default: base.fonts[0]
  },
  colors: {
    neutral: {
      "000": base.colors.neutral[0],
      "050": base.colors.neutral[1],
      "080": base.colors.neutral[2],
      "100": base.colors.neutral[3],
      "200": base.colors.neutral[4],
      "300": base.colors.neutral[5],
      "400": base.colors.neutral[6],
      "500": base.colors.neutral[7],
      "600": base.colors.neutral[8],
      "700": base.colors.neutral[9],
      "800": base.colors.neutral[10]
    },
    brand: {
      "100": base.colors.brand[0],
      "200": base.colors.brand[1],
      "250": base.colors.brand[8],
      "300": base.colors.brand[2],
      "400": base.colors.brand[3],
      "500": base.colors.brand[4],
      "600": base.colors.brand[5],
      "700": base.colors.brand[6],
      "800": base.colors.brand[7]
    },
    success: {
      "300": base.colors.success[0],
      "400": base.colors.success[1],
      "600": base.colors.success[2],
      "900": base.colors.success[3],
      "950": base.colors.success[4]
    },
    warning: {
      "400": base.colors.warning[0],
      "500": base.colors.warning[1],
      "600": base.colors.warning[1],
      "900": base.colors.warning[2],
      "950": base.colors.warning[3]
    },
    danger: {
      "200": base.colors.danger[0],
      "400": base.colors.danger[1],
      "600": base.colors.danger[2],
      "900": base.colors.danger[3],
      "950": base.colors.danger[4]
    }
  },
  shadows: {
    xs: base.shadows[0],
    s: base.shadows[1],
    m: base.shadows[2],
    l: base.shadows[3],
    xl: base.shadows[4]
  },
  breakpoints: {
    ...base.breakpoints,
    xsmall: base.breakpoints[3],
    small: base.breakpoints[0],
    medium: base.breakpoints[1],
    large: base.breakpoints[2]
  },
  media: getBreakpoints({
    xsmall: base.breakpoints[3],
    small: base.breakpoints[0],
    medium: base.breakpoints[1],
    large: base.breakpoints[2]
  }),
  zIndex: {
    dialog: base.zIndex[0],
    popper: base.zIndex[1],
    tooltip: base.zIndex[2],
    backdrop: base.zIndex[3],
    loader: base.zIndex[4]
  },
  states: {
    _: base.states[0],
    motionSafe: base.states[1],
    motionReduce: base.states[2],
    first: base.states[3],
    last: base.states[4],
    odd: base.states[5],
    even: base.states[6],
    visited: base.states[7],
    checked: base.states[8],
    focusWithin: base.states[9],
    hover: base.states[10],
    focus: base.states[11],
    focusVisible: base.states[12],
    active: base.states[13],
    disabled: base.states[14],
    placeholder: base.states[15]
  }
});
export {
  getAlias
};
